import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const sessionId = new URLSearchParams(hash.replace('#', '?')).get('session_id');

    if (!sessionId) {
      navigate('/admin/login');
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.detail || 'Falha na autenticação');
        }

        const user = await res.json();
        // Clean URL and navigate to dashboard with user data
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/admin/dashboard', { state: { user } });
      } catch (error) {
        navigate('/admin/login', { state: { error: error.message || 'Falha na autenticação' } });
      }
    };

    exchangeSession();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#00A8B5] to-[#2DD4BF] flex items-center justify-center">
      <div className="text-center text-white">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        <p className="text-lg font-medium">Autenticando...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
